import { api } from './config';
import { user } from 'localStorage';

const notifApi = api();

// Staff/admin are `User` accounts → persisted staff feed (/user/me/notifications).
// Customers (clientAuthen) → /client/notifications. This module is shared by both
// the admin layout and the customer portal, so pick the endpoint by who is logged in.
function notifBase() {
  try {
    const u = typeof user === 'function' ? user() : null;
    if (u && (u._id || u.id || u.email)) return '/user/me/notifications';
  } catch (e) {
    /* ignore — fall back to client */
  }
  return '/client/notifications';
}

export const listMyNotifications = async ({ limit = 50, unreadOnly = false } = {}) => {
  try {
    const r = await notifApi.get(notifBase(), { params: { limit, unreadOnly } });
    return r.data;
  } catch (e) {
    return e.response?.data || { success: false, message: e.message };
  }
};

export const markNotificationRead = async (id) => {
  try {
    const r = await notifApi.patch(`${notifBase()}/${encodeURIComponent(id)}/read`);
    return r.data;
  } catch (e) {
    return e.response?.data || { success: false, message: e.message };
  }
};

export const markAllNotificationsRead = async () => {
  try {
    const r = await notifApi.patch(`${notifBase()}/read-all`);
    return r.data;
  } catch (e) {
    return e.response?.data || { success: false, message: e.message };
  }
};
